import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return 'Rp.\u00a00';
  // Reveal fractional rupiah when the difference is non-integer (strict balance check).
  const hasFraction = Number(amount) % 1 !== 0;
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: hasFraction ? 2 : 0
  }).format(amount).replace('Rp', 'Rp.');
};

const BalanceWarning = ({ isBalanced, difference }) => {
  if (isBalanced) return null;

  return (
    <Card className="bg-yellow-50 border-yellow-200">
      <CardContent className="pt-6">
        <div className="flex items-start gap-3">
          <AlertCircle className="text-yellow-600 mt-1" size={20} />
          <div>
            <p className="text-sm text-yellow-900 font-medium">Peringatan</p>
            <p className="text-sm text-yellow-800 mt-1">
              Balance sheet tidak seimbang. Selisih: {formatCurrency(difference)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BalanceWarning;
